import { farasod } from "./api"

const endpoint = "/layout"

export const getLayout = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const changeLayout = async (data) => {
  const response = await farasod.patch(`${endpoint}`, data)

  return response.data
}